import {Command} from '@application/command/command';
import {CalendarItemGroup} from '@domain/planning/calendar-item-group';
import {PlanningItem} from '@domain/planning/planning-item';
import {each, findIndex, isEqual} from 'lodash-es';
import {RescheduleOverlappingItemsCommand} from '../reschedule-overlapping-items/reschedule-overlapping-items-command';
import {AddUnplannedOrderToRunParameters} from './add-unplanned-order-to-run-parameters';

export class AddUnplannedOrderToRunCommand implements Command<AddUnplannedOrderToRunParameters, CalendarItemGroup[]> {
  public execute(commandArgs: AddUnplannedOrderToRunParameters): CalendarItemGroup[] {
    const {unplannedPlanningOrder, run, planningOrderPosition, machine, groupedCalendarItems} = commandArgs;

    run.planningOrders.splice(planningOrderPosition, 0, unplannedPlanningOrder);
    run.rescheduleBasedOnPlanningOrders();

    const groupedCalendarItemIndex = findIndex(groupedCalendarItems, {machineId: machine.id});
    const groupedCalendarItem = groupedCalendarItems[groupedCalendarItemIndex];

    each(groupedCalendarItem.items as PlanningItem[], (planningItem: PlanningItem, index: number) => {
      if (isEqual(planningItem.uniqueId, run.uniqueId)) {
        groupedCalendarItem.items[index] = run;
        return false;
      }
    });

    new RescheduleOverlappingItemsCommand().execute({planningItem: run, groupedCalendarItem});

    groupedCalendarItems[groupedCalendarItemIndex] = groupedCalendarItem;

    return groupedCalendarItems;
  }
}
